import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getTeamsQuery } from './api.get-teams.query.js';
import { updateTeamRequest } from './api.update-team.request.js';

function useUpdateTeamMutation() {
  const client = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(updateTeamMutation(client, notifier, user));
}

/**
 * Updates a course optimisticly and reverts in case anything fails on the
 * backend.
 */
const updateTeamMutation = (client, notifier, user) => {
  return {
    mutationKey: ["user-area/teams/update", user?.id],
    mutationFn: updatedTeam => updateTeamRequest(user, updatedTeam),
    onMutate: async updatedTeam => {
      const data = client.getQueryData(getTeamsQuery.queryKey({
        user
      }));
      const old = data?.find(it => it.id === updatedTeam.id);
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => previous?.map(it => it.id === updatedTeam.id ? updatedTeam : it));
      await client.cancelQueries({
        queryKey: getTeamsQuery.queryKey({
          user
        })
      });
      return {
        optimistic: updatedTeam,
        old
      };
    },
    onSuccess: result => {
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => previous?.map(it => it.id === result.id ? result : it));
    },
    onError: (error, _, context) => {
      notifier.notify({
        id: "user-area.teams.update.error",
        type: "error",
        body: "Holdet kunne ikke opdateres. Prøv igen om lidt."
      });
      client.setQueryData(getTeamsQuery.queryKey({
        user
      }), previous => previous?.map(course => course.id === context?.optimistic.id ? context?.old ?? course : course));
    }
  };
};

export { useUpdateTeamMutation };
//# sourceMappingURL=api.update-team.mutation.js.map
